var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeAddToCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#E3FB94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2 24.143c.382 0 .748.15 1.018.418a1.423 1.423 0 010 2.02 1.446 1.446 0 01-2.036 0 1.423 1.423 0 010-2.02c.27-.268.636-.418 1.018-.418zm7.2 0c.382 0 .748.15 1.018.418a1.423 1.423 0 010 2.02 1.446 1.446 0 01-2.036 0 1.423 1.423 0 010-2.02c.27-.268.636-.418 1.018-.418zM11.6 12a.724.724 0 01.682.484l.021.08.497 2.297h12.478a.726.726 0 01.529.23.713.713 0 01.189.541l-.013.082-1.437 7.137a.713.713 0 01-.621.569l-.085.005H13.76a.724.724 0 01-.682-.484l-.021-.08-2.04-9.432H8.72a.724.724 0 01-.478-.18.713.713 0 01-.237-.451L8 12.714c0-.175.065-.344.182-.474a.722.722 0 01.454-.235L8.72 12h2.88zm12.8 4.29H13.11l1.232 5.707h8.908l1.15-5.708z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--add-to-cart-f0dcab5978be4ff17cb53179b589f5a7.svg";
export { SvgIconCircleLimeAddToCart as Component };